import React from 'react'
import { Redirect } from 'react-router-dom'

import useAuth from '../../hooks/useAuth'
import { isBo } from '../../utils/CommonMethods'

function AuthGuard({ children }) {
  const { isLoggedIn } = useAuth()
  if (!isLoggedIn) {
    let urlRedirect = '/auth/signin'
    if (isBo()) {
      urlRedirect = '/bo/auth/signin'
    }
    return <Redirect to={urlRedirect} />
  }

  return children
}

export default AuthGuard

